import {FC, useMemo, useState} from 'react';
import {toast} from 'react-toastify';
//mui
import {Box, Typography} from '@mui/material';
//store
import {getAttendee, getAttendeeSelector} from '@/store/organization-attendees';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
//services
import {OrganizationAttendeesService} from '@/utils/services';
//constants
import {
	BLOCK_ACCOUNT,
	BLOCK_USER,
	BODY2,
	CANCEL,
	ERROR,
	RESTORE_ACCOUNT,
	SUBTITLE1,
	SUCCESS,
	TEXT,
} from '@/utils/constants';
//components
import Button from '@/shared/components/Button';
import Modal from '@/shared/components/Modal';
//helpers
import {getErrorMessage} from '@/utils/helpers';
//icons
import {ReactComponent as DangerIcon} from '@icons/danger.svg';
//styles
import {blockAttendeeAccountStyle} from './BlockAttendeeAccount.styles';

const BlockAttendeeAccount: FC = () => {
	const dispatch = useAppDispatch();

	const attendee = useAppSelector(getAttendeeSelector);

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

	const handleBlockAccountButtonClick = async () => {
		try {
			if (attendee) {
				await OrganizationAttendeesService.updateAttendeeAccountStatus(attendee.id, !attendee.isBlocked);
				await dispatch(getAttendee(attendee.id)).unwrap();
				if (isDeleteModalOpen) handleBlockAccountModalOpen();
			}
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	const handleBlockAccountModalOpen = () => setIsDeleteModalOpen(!isDeleteModalOpen);

	const buttonTitle = useMemo(() => (attendee?.isBlocked ? RESTORE_ACCOUNT : BLOCK_ACCOUNT), [attendee?.isBlocked]);
	const buttonColor = useMemo(() => (attendee?.isBlocked ? SUCCESS : ERROR), [attendee?.isBlocked]);
	const buttonClickFunction = useMemo(
		() => (attendee?.isBlocked ? handleBlockAccountButtonClick : handleBlockAccountModalOpen),
		[attendee?.isBlocked]
	);

	return (
		<Box sx={blockAttendeeAccountStyle.wrapper}>
			<Box sx={blockAttendeeAccountStyle.title}>
				<Typography variant={SUBTITLE1}>{BLOCK_ACCOUNT}</Typography>
				<Typography variant={BODY2}>
					If a user violates the auction rules or event policy, you can block them.
				</Typography>
			</Box>

			<Button
				title={buttonTitle}
				sx={blockAttendeeAccountStyle.button}
				onClick={buttonClickFunction}
				variant={TEXT}
				color={buttonColor}
				disableRipple
			/>

			<Modal
				title={BLOCK_USER}
				description="Are you sure you want to block this user?"
				closeButtonTitle={CANCEL}
				mainButtonTitle={BLOCK_USER}
				onClose={handleBlockAccountModalOpen}
				onSave={handleBlockAccountButtonClick}
				open={isDeleteModalOpen}
				mainIcon={<DangerIcon />}
				sx={blockAttendeeAccountStyle.modal}
				color={ERROR}
				isShowCloseButton
				isShowSaveButton
			/>
		</Box>
	);
};

export default BlockAttendeeAccount;
